<!-- <app-preloader></app-preloader> -->
<router-outlet></router-outlet>
<ngx-ui-loader [bgsTemplate]="backgroundSpinner" bgsPosition="center-center"></ngx-ui-loader>

<ng-template #backgroundSpinner>
  <div>
    <div class="hm-spinner"></div>
  </div>
</ng-template>